<template>
  <div class="meeting-embed" :style="`--width: ${$vuetify.breakpoint.width*0.8}px`">
    <div class="meeting-embed__header">
			<div class="meeting-embed__identity">
				<span class="meeting-embed__icon"><portal-icon name="calendar-days" :size="19" /></span>
				<span>{{ $t('meetings.schedule.heading') }}</span>
			</div>
			<button type="button" :aria-label="$t('global.close')" @click="$emit('result')">
				<portal-icon name="x" :size="20" />
			</button>
    </div>
    <div class="meeting-embed__body">
      <iframe :src="finalUrl" :id="`frame-${frameId}`" class="responsive-iframe"></iframe>
    </div>
  </div>
</template>

<script>
	import iFrameResize from 'iframe-resizer/js/iframeResizer';
	import { v4 as uuid4 } from 'uuid';
	import PortalIcon from '@/components/PortalIcon';

	export default {
		name: 'MeetingEmbed',

		props: ['frameUrl'],

		components: { PortalIcon },

		data: function() {
			return {
				frameId: uuid4().replaceAll('-', ''),
				resizerOptions: {
					log: false,
					heightCalculationMethod: 'min',
					sizeWidth: true,
					sizeHeight: true,
				},
			};
		},

		mounted() {
			iFrameResize(this.resizerOptions, `#frame-${this.frameId}`);
			window.addEventListener('message', this.handleFrameMessage);
		},

		beforeDestroy() {
			window.removeEventListener('message', this.handleFrameMessage);
		},

		methods: {
			handleFrameMessage(e) {
				if (e.data.startsWith('[iFrameSizer]')) {
					return;
				}

				console.log('Frame message received', e);
				this.$emit('frame-event', e);
			},
		},

		computed: {
      finalUrl: function(){
        let result = new URL(this.frameUrl);
        result.searchParams.append('knownUser','true');
        result.searchParams.append('firstName',this.$store.state.loggedInUser.firstName);
        result.searchParams.append('lastName',this.$store.state.loggedInUser.lastName);
        result.searchParams.append('email',this.$store.state.loggedInUser.email);
        result.searchParams.append('phone',this.$store.state.loggedInUser.phone);
        return result.href;
      }
    },
	};
</script>

<style scoped lang="scss">
	.meeting-embed {
		width: min(var(--width), calc(100vw - 32px));
		min-width: min(var(--width), calc(100vw - 32px));
		max-height: calc(var(--vh) - 32px);
		min-height: 500px;
		display: flex;
		flex-direction: column;
		overflow: hidden;
		border: 1px solid var(--v-gray_30-base);
		border-radius: var(--brand-surface-radius, 22px);
		background: var(--v-white-base);
		box-shadow: 0 28px 80px rgba(22, 24, 35, 0.18);

		&__header {
			min-height: 68px;
			padding: 10px 12px 10px 18px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			border-bottom: 1px solid var(--v-gray_30-base);

			button {
				width: 40px;
				height: 40px;
				border: 1px solid var(--v-gray_30-base);
				border-radius: var(--brand-button-radius, 50%);
				background: var(--v-white-base);
				color: var(--v-gray_70-base);
				display: inline-flex;
				align-items: center;
				justify-content: center;

				&:hover {
					background: var(--v-gray_10-base);
					color: var(--v-gray_90-base);
				}
			}
		}

		&__identity {
			display: flex;
			align-items: center;
			gap: 11px;
			font-size: 17px;
			font-weight: 650;
			color: var(--v-gray_90-base);
		}

		&__icon {
			width: 40px;
			height: 40px;
			display: inline-flex;
			align-items: center;
			justify-content: center;
			border-radius: 13px;
			background: var(--v-primary_10-base);
			color: var(--v-primary-base);
		}

		&__body {
			flex: 1 1 auto;
			min-height: 0;
			overflow: auto;
		}
	}

	.responsive-iframe {
		padding: 0px;
		margin: 0px;
		border: 0;
		max-width: 100%;
		min-width: 100%;
		min-height: 500px;
		display: block;
	}

	@media (max-width: 600px) {
		.meeting-embed {
			width: 100vw;
			min-width: 100vw;
			min-height: var(--vh);
			max-height: var(--vh);
			border: 0;
			border-radius: 0;

			&__header {
				min-height: 64px;
				padding: 10px 12px;
			}
		}
	}
</style>
